import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CustomerService } from './auth/customer.service';
import { MODEL_FACTORIES } from './factories';
import { UserResource } from './user.resource';
import { RoleResource } from './role.resource';
import { CustomerResource } from './customer.resource';
import { PermissionService } from './auth/permission.service';
import { AuthenticationService } from './auth/authentication.service';
import { UserService } from './auth/user.service';
import { AppJwtModule } from './jwt.module';

@NgModule({
  imports: [
    HttpClientModule,
    AppJwtModule,
  ],
  providers: [
    AuthenticationService,
    PermissionService,
    CustomerService,
    UserService,
    ...MODEL_FACTORIES,
    UserResource,
    RoleResource,
    CustomerResource,
  ],
})
export class ResourceModule {}



// WEBPACK FOOTER //
// ./src/app/resources/resource.module.ts